import { Capacitor } from '@capacitor/core';
//import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support';
import { StatusBar } from '@capacitor/status-bar';

export const configureStatusBar = async () => {
    if (Capacitor.isNativePlatform()) {
        if (Capacitor.getPlatform() === 'android') {
            // Parece que hay algún problema con el plugin, y a veces
            // configura bien el statusbar y otras no, con el timeout parece que lo hace mejor.
            // https://github.com/ionic-team/capacitor-plugins/issues/1720
            await setTimeout(async () => {
                await StatusBar.setOverlaysWebView({ overlay: false });
                //await StatusBar.setBackgroundColor({ color: '#498b2a' });
                //await EdgeToEdge.setBackgroundColor({ color: '#498b2a' });
            }, 500);
        }
    }
};
